import React, { useContext, useState, useEffect } from "react";
import { useHistory, Redirect, useParams } from "react-router-dom";
import { Div } from 'themes/jumbo/@jumbo/shared';
import { JumboDdMenu } from 'themes/jumbo/@jumbo/components';
import {
    IconButton,
    List,
    ListItem,
    Avatar,
    ListItemSecondaryAction,
    ListItemText,
    Checkbox,
    Menu,
    MenuItem,
    Chip,
    Button,
    Stack,
    Card,
    Tooltip,
    Typography,
    useTheme
} from "@mui/material";
import _ from 'utils/@lodash';
import {CatalogContext} from "views/Catalog";
import { addRawData } from "store/main/selectedRawData";
import LockIcon from '@mui/icons-material/Lock';
import { tss } from "tss-react/mui";
//import { Scrollbars } from "react-custom-scrollbars";
import { CircularProgressWithLabel } from "components";
import { EntityProperties } from "panels";
import { icons } from "constants/viewer";
import { defaultViewProgram } from "constants/viewer";
import { getFileIcon } from "actions/GlobalActions";
import { FoldersActions } from "actions";
import * as Utils from "services/UtilsService";
import RenameItemPanel from "./RenameItemPanel";
import DeleteItemsPanel, { DeleteItem } from "panels/DeleteItemsPanel";
import ActivateVersionPanel from "./ActivateVersionPanel";
import EventsEmitter from "events/EventsEmitter";
import { MoreHoriz, Public, Folder, ErrorOutlineRounded, CheckCircleOutlineRounded } from "@mui/icons-material";
import { ReactComponent as File } from "assets/images/file.svg";
import commonStyles, { folderColor, rowHeight, panelBackgroundColor } from "styles/common";
import { useJumboDialog } from 'themes/jumbo/@jumbo/components/JumboDialog/hooks/useJumboDialog';
import { useJumboTheme } from 'themes/jumbo/@jumbo/components/JumboTheme/hooks';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VerifiedIcon from '@mui/icons-material/Verified';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { trackEvent } from "components/Tracking";
import CachedIcon from '@mui/icons-material/Cached';  
import { alpha } from '@mui/material/styles';
import VisibilityIcon from '@mui/icons-material/Visibility';
//New projects module
import { useDispatch } from 'react-redux';
import {
	openEditDialog
} from 'store/projects';
import ObjectsListPanel from "./ObjectsListPanel";
import { viewableEntitiesType } from "constants/common";
import { openObjectDialog} from 'store/main/viewObjects';
import CreateObjPanel from "./CreateObjPanel";
import CreateProcessPanel from "./CreateProcessPanel";
import VoxelTerrain from "./CreateProcessPanel/VoxelTerrain";
import IndexedPoint from "./CreateProcessPanel/IndexedPoint";
import DrillHoleDatabase from "./CreateProcessPanel/DrillHoleDatabase";
import GeoChem from "./CreateProcessPanel/GeoChem";
import OrthoVoxelTerrain from "./CreateProcessPanel/OrthoVoxelTerrain";
import VoxelizedMesh from "./CreateProcessPanel/VoxelizedMesh";
import IndexedMesh from "./CreateProcessPanel/IndexedMesh";
import VoxelBlockModel from "./CreateProcessPanel/VoxelBlockModel";
import VoxelPointCloud from "./CreateProcessPanel/VoxelPointCloud"
import Unity from "./CreateOutputPanel/Unity";
import IndexedImagery from "./CreateProcessPanel/IndexedImagery";
import SubscriptionDialog from 'components/SubscriptionDialog';
import useSwalWrapper from 'themes/jumbo/@jumbo/vendors/sweetalert2/hooks';
import { MenuItemProps } from 'themes/jumbo/@jumbo/types';
import {AppContext} from "views/Loader";
import CustomScroll from "components/CustomScroll";
import { 
    openIndexedPointDialog,
    openDrillHoleDatabaseDialog,
    openGeoChemDialog,
    openVoxelTerrainDialog,
    openOrthoVoxelTerrainDialog,
    openVoxelizedMeshDialog,
    openIndexedMeshDialog,
    openVoxelBlockModelDialog,
    openIndexedImageryDialog
} from 'store/main/viewObjects';


export const useStyles = tss.create(({theme}) => ({
    root: {
        width: "100%",
        height: "calc(100% - 133px)",
        minHeight: 200,
        position: "relative",
    },
    list: {
        width: "100%",
        height: "100%",
        minHeight: 160,
        paddingTop: 0,
        paddingBottom: 0,
        //backgroundColor: panelBackgroundColor,
        //boxShadow: "1px 1px 13px 0px #00000012",
    },
    icon: {
        width: 24,
        height: 24,
        color: theme.palette.primary.main
    },
    iconBig: {
        width: 50,
        height: 50,
        color: theme.palette.primary.main
    },
    layerIcon: {
        display: "inline-flex",
        alignItems: "center",
    },
    iconContainer: {
        height: 42,
        width: 37,
    },
    label: {
        position: "relative",
        top: 1,
        height: 42,
    },
    checkbox: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: rowHeight,
        height: rowHeight,
    },
    firstCol: {
        paddingLeft: 20,
        width: 270,
        minWidth: '60%',
        maxWidth: "100%",
        textAlign: "left",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        cursor: "pointer",
    },
    firstColCheckbox: {
        paddingLeft: 10,
        flex: 1,
        maxWidth: "100%",
        textAlign: "left",
        /*textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",*/
        cursor: "pointer",
    },
    secondCol: {
        textAlign: "left",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        height: "100%",
    },
    thirdCol: {
        minWidth: 30,
        //width: 64,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
    },
    fourthCol: {
        minWidth: 100,
        width: 100,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
    },
    labelCol: {
        maxWidth: 150,
        textOverflow: "ellipsis",
        overflow: "hidden",
        marginRight: 30
    },
    tabs: {
        minHeight: 200,
        width: "100%",
        paddingTop: 0,
        backgroundColor: "white",
        borderTop: "solid 1px #f0f0f0",
    },
    button: {
        minWidth: 20,
        padding: "5px 5px",
        marginLeft: 5,
        width: 75,
        height: 36,
    },
    buttonDownload: {},
    row: {
        height: rowHeight,
        minHeight: rowHeight,
        display: "inline-flex",
        alignItems: "center",
        borderBottom: "solid 1px #f0f0f0",
        backgroundColor: "#ffffff",
    },
    dataset: {},
    entityCard: {
        backgroundColor: "#f7f7f7",
    },
    content: {
        padding: 30,
        paddingLeft: 0,
    },
    typography: {
        width: "100%",
    },
    table: {},
    textField: {
        width: 300,
    },
    middle: {
        verticalAlign: "middle",
    },
    inner: {
        position: "relative",
        top: "7px",
    },
    td: {
        height: 40,
    },
    comment: {
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        //textAlign: "center",
        //marginLeft: 10,
    },
    user: {
        minWidth: 50,
        //width: 60,
        borderRadius: "25px",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        background: "rgba(32,32,32,.07)",
        fontSize: '13px',
        color: "rgba(0,0,0,.65)",
        textAlign: "center",
        marginRight: "10px",
    },
    ellipsis: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box"
    },
    multiLineEllipsis: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical"
    },
    '.MuiAvatar-root': {
        "& svg": {
            color: theme.palette.text.primary,
            fill: theme.palette.text.primary,
            "& path": {
                stroke: theme.palette.text.primary,
            }
        }
    }
}));


interface TProcessing {
    "id" : string,
    "progress" : number,
    "label" : string
}


const substringLabel = (strPath:any) => {
    if (strPath && strPath.length > 30) {
        return strPath.substring(0, 25) + "...";
    }else
        return strPath
}

function getIcon(entity: any, classes?: any, common?: any, big: boolean = false) {
    var fileName = getFileIcon(entity);
    //console.log("fileName:", fileName);
    //console.log("entity:", entity);
    if (!fileName) {
        return <File className={big ? classes?.iconBig : classes?.icon} style={{ width: '85%', height: '85%' }} />;
    }
    const curIcons = { ...icons };
    var Icon = curIcons[fileName];
    if (!Icon) {
        Icon = curIcons["FILE"];
    }
    return (
        <Icon className={big ? classes?.iconBig : classes?.icon} style={{ width: '85%', height: '85%' }} />
    );
}

interface IType {
    name : string;
    id : string;
}

function Entities(props: { catalogId: any; setCatalog: any; cacheLastUpdate: number; catalog: any; entities: any;}) {
    const { classes: common } = commonStyles();
    const { classes, cx } = useStyles();
    const history = useHistory();
    var { catalogId } = useParams();
    const [entity, setEntity] = useState<any>(null);
    const [anchorEl, setAnchor] = useState(null);
    const [open, setOpen] = useState("");
    const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
    const { showDialog, hideDialog } = useJumboDialog();
    const { theme } = useJumboTheme();
    const [listObjects, setListObjects] = useState<IType[]>([])
    const [processingIDs, setProcessingIDs] = useState<{ [id: string]: TProcessing }>({});
    
    const { 
        selectedItems,
        setSelectedItems,
        allItemsChecked,
        setAllItemsChecked,
        entities,
        setEntities,
        setCatalog,
        cacheLastUpdate,
        catalog,
        hasFullAccess,
        hasProjectAccess,
        hasActiveSubscription,
        storage_limit_exceeded,
        processtime_limit_exceeded,
        isDefaultProject,
        defaultProjects,
        demoProjectsHidden, 
    } = useContext<any>(CatalogContext);
    const type = catalogId === "0" || catalogId === "all" ? "projects" : catalog.file_type;

    const Swal = useSwalWrapper();


    const sweetAlerts = () => {
        Swal.fire({
        title: 'Your account has limited access!',
        text: 'We have limited your access to some features. Please upgrade your current plan to access this feature.',
        /*imageUrl: getAssetPath(
            `assets/images/subscription.webp`,
            '450x200'
        ),*/
        imageWidth: 450,
        imageHeight: 200,
        imageAlt: 'Custom image',
        confirmButtonText: "Upgrade my plan",
        showCloseButton: true,
        }).then((result) => {
            result.isConfirmed && history.push("/profile");
        });
    };


    const handleMoreAction = React.useCallback(

        (menuItem: MenuItemProps) => {

        if (isDefaultProject || !hasActiveSubscription) {
            !hasActiveSubscription && sweetAlerts();
            return;
        }
        switch (menuItem?.action) {
            case 'activeversion':
                setOpen("activateItem");
                break;
            case 'rename':
                setOpen("renameItem");
                break;
            case 'edit':
                dispatch(openEditDialog(entity));
                break;
            case 'indexedPoints' : 
                dispatch(openIndexedPointDialog({objName : 'Indexed Points', objType : 'RAWPC', objSources : [...listObjects]}))
                break;
            case 'drillHoleDatabase' : 
                dispatch(openDrillHoleDatabaseDialog({objName : 'Drill Hole Database', objType : 'RAWDH', objSources : [...listObjects]}))
                break;
            case 'geochem' : 
                dispatch(openGeoChemDialog({objName : 'Geo Chem', objType : 'RAWGEOCHEM', objSources : [...listObjects]}))
                break;
            case 'voxelTerrain' : 
                dispatch(openVoxelTerrainDialog({objName : 'Voxel Terrain', objType : 'RAWPC', objSources : [...listObjects]}))
                break;
             case 'indexedMesh' : 
                dispatch(openIndexedMeshDialog({objName : 'Indexed Mesh', objType : 'RAWMESH', objSources : [...listObjects]}))
                break;
            case 'orthoVoxelTerrain' : 
                dispatch(openOrthoVoxelTerrainDialog({objName : 'Ortho Voxel Terrain', objType : 'RAWMESH', objSources : [...listObjects]}))
                break;
            case 'voxelMesh' : 
                dispatch(openVoxelizedMeshDialog({objName : 'Voxel Mesh', objType : 'RAWMESH', objSources : [...listObjects]}))
                break;
            case 'voxelBlockModel' : 
                dispatch(openVoxelBlockModelDialog({objName : 'Voxel Block Model', objType : 'RAWBM', objSources : [...listObjects]}))
                break;
            case 'indexedImagery' : 
                dispatch(openIndexedImageryDialog({objName : 'Indexed Imagery', objType : 'ORTHO', objSources : [...listObjects]}))
                break;

            case 'delete':
                showDialog({
                    variant: 'confirm',
                    title: 'Are you sure?',
                    content: 'Once you delete a project that cannot be reversed.',
                    onYes: () => {
                        DeleteItem(defaultProjects, [entity.ID])
                        hideDialog();
                    },
                    onNo: () => hideDialog(),
                });
                break;
            case 'view':
                viewCatalog(entity);
            
        }
        },
        [showDialog, Swal, hideDialog]
    );


    useEffect(() => {

        const reload = (object: any) => {
            
            const data = object?.data;
            
            if(data && typeof object["data"]["partial_status"] === "string" && object["data"]["partial_status"].length > 0 && typeof object["data"]["file_size"] === "undefined"){
                
                const newItem : TProcessing = {
                    id : object["id"],
                    progress : object["data"]["partial_progress"],
                    label : object["data"]["partial_status"]
                }
                
                setProcessingIDs(prev => ({
                    ...prev,
                    [newItem.id]: newItem
                }));
            }
        };
        EventsEmitter.on("signalr_update", reload);
        return () => {
            EventsEmitter.removeEventListener("signalr_update", reload);
        };

    }, []);


    useEffect(() => {

        if(!cacheLastUpdate) return;
        FoldersActions.buildFolderTree(FoldersActions.filter, catalogId, () => {
            const _catalog = FoldersActions.getCatalog(catalogId);
            if(!_catalog) return;
            setCatalog(_catalog);
            const _cachedEntities = FoldersActions.listFolderItems(_catalog, _catalog.file_type);
            const cachedEntities = _cachedEntities
                ?.filter((item: any) => !demoProjectsHidden || (!defaultProjects.includes(item.ID) &&  !defaultProjects.includes(item.project))) 
            setEntities(cachedEntities);
            setLoading(type === 'projects');
        })
    }, [cacheLastUpdate, catalogId, demoProjectsHidden, defaultProjects])

    const AddObject = (props:any) => {
        const {catalogId, projectId, isFolder} = props;

        const AddObjectBtn = (props: { onClick? : () => void}) => {
            const { onClick } = props;

            return (
                <Button 
                    onClick={(ev: any) => {
                        trackEvent("Raw Data", "Add Object", "Btn")
                        ev.stopPropagation();
                        !onClick && handleOpenedObjectPanel(projectId);
                        onClick && onClick();
                    }}
                    variant="contained" 
                    size="small"
                    disabled={isDefaultProject}
                    id="add-object-btn"
                >
                    Add Object
                </Button>
            );
        }

        return (
            <>
                <CreateProcessPanel catalogId={catalogId} isFolder={isFolder}/>
                <VoxelTerrain project={projectId} catalogId={catalogId} file_type="VOXSURF" source_type="RAWPC" name="Voxel Terrain" isFolder={isFolder}/>
                <IndexedPoint project={projectId} catalogId={catalogId} file_type="IDXPC" source_type="RAWPC" name="Indexed Point" isFolder={isFolder}/>
                <DrillHoleDatabase project={projectId} catalogId={catalogId} file_type="IDXDH" source_type="RAWDH" name="Drill Hole Database" isFolder={isFolder}/>
                <GeoChem project={projectId} catalogId={catalogId} file_type="GEOCHEM" source_type="RAWGEOCHEM" name="Geo Chem" isFolder={isFolder}/>
                <OrthoVoxelTerrain project={projectId} catalogId={catalogId} file_type="ORTHOVOX" source_type="RAWMESH" name="Ortho Voxel Terrain" isFolder={isFolder}/>
                <VoxelizedMesh project={projectId} catalogId={catalogId} file_type="VOXMESH" source_type="RAWMESH" name="Voxelized Mesh" isFolder={isFolder}/>
                <IndexedMesh project={projectId} catalogId={catalogId} file_type="IDXMESH" source_type="RAWMESH" name="Indexed Mesh" isFolder={isFolder}/>
                <VoxelBlockModel project={projectId} catalogId={catalogId} file_type="VOXBM" source_type="RAWBM" name="Voxel Block Model" isFolder={isFolder}/>
                <VoxelPointCloud project={projectId} catalogId={catalogId} file_type="VOXPC" source_type="RAWBM" name="Voxel Point Cloud" isFolder={isFolder}/>
                <IndexedImagery project={projectId} catalogId={catalogId} file_type="IDXORTHO" source_type="ORTHO" name="Indexed Imagery" isFolder={isFolder}/>
                <Unity project={projectId} catalogId={catalogId} name="Unity Project" isFolder={isFolder}/>
                
                <CreateObjPanel project={projectId} catalogId={catalogId} isFolder={isFolder}/>
                { hasProjectAccess && (
                    <div style={{textAlign:'right'}}>
                        { hasActiveSubscription && !(processtime_limit_exceeded || storage_limit_exceeded) ? <AddObjectBtn /> : <SubscriptionDialog Component={AddObjectBtn} /> }
                        <ObjectsListPanel />
                    </div>
                )}
            </>
        );
    }

    const handleOpenedObjectPanel = (projectId:any) => {
        if (isDefaultProject) return;

        dispatch(openObjectDialog({project: projectId}))
    }


    const EntitiesListHeader = () => {

        const { showDialog, hideDialog } = useJumboDialog();
        
        
        const handleBulkDelete = (e: any) => {
          showDialog({
            variant: 'confirm',
            title: 'Are you sure?',
            content: 'You won\'t be able to recover these projects later',
            onYes: () => {
                DeleteItem(defaultProjects);
                hideDialog();
                setTimeout(() => {
                    setSelectedItems([]);
                }, 1000)
                
            },
            onNo: hideDialog,
          });
        };

        const DeleteProjectsBtn = (props: { onClick? : () => void}) => {
            const { onClick } = props;

            return (
                <div>
                    <Button
                        variant='contained'
                        color={'error'}
                        disableElevation
                        size='small'
                        startIcon={<DeleteIcon />}
                        disabled={isDefaultProject}
                        onClick={(ev: any) => {
                            ev.stopPropagation();
                            if(isDefaultProject) return;
                            !onClick && handleBulkDelete(ev);
                            onClick && onClick();
                        }}
                    >
                        Delete selected
                    </Button>
                </div>
            );
        }
        //console.log(catalogId, catalog, '---------------------------here-------------------------------')
        const projectId = catalog.file_type === 'FOLDER' ? catalog.project : catalogId;

        const isFolder  = catalog?.entity?.file_type === 'FOLDER' ? true : false;

        return entities?.length > 0 ? (
            <>
                <ListItem component='div' style={{paddingLeft: '8px'}}>
                    <ListItemText
                        primary={
                            <Stack direction={'row'} spacing={2}>
                                <Div sx={{display: 'flex', justifyContent: 'space-between', width: '100%', flexDirection: {xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row'}}}>
                                    <label style={{display: 'flex', gap: '3px', alignItems: 'center', cursor: 'pointer'}}>
                                        <Checkbox
                                            color='primary'
                                            checked={allItemsChecked}
                                            onChange={selectAllItems}
                                            disabled={isDefaultProject || !hasFullAccess}
                                            sx={{ml: {xs: '-10px', sm: '-10px', md: '0px', lg: '0px', xl: '0px'}}}
                                        />
                                        <Typography
                                            fontSize={'14px'}
                                            variant={'body1'}
                                            color={'text.secondary'}
                                        >
                                            Select All
                                        </Typography>
                                    </label>
                                    <Div sx={{display: 'flex', gap: '15px'}}> 
                                    { 
                                    (catalogId === catalog.project || catalog.file_type === 'FOLDER') && <AddObject catalogId={catalogId} projectId={projectId} isFolder={isFolder}/>}
                                        { selectedItems.length > 0 && hasProjectAccess ? (
                                           <> { hasFullAccess ? <DeleteProjectsBtn /> : <SubscriptionDialog Component={DeleteProjectsBtn} /> }</>
                                        ): ""}
                                        </Div>
                                </Div>
                            </Stack>
                        }
                    />
                </ListItem>
            </>
        ) : <>
            {(catalogId === catalog.project || catalog.file_type === 'FOLDER') && <AddObject catalogId={catalogId} projectId={projectId} isFolder={isFolder}/>}
        </>;
    };

    const handleCheckboxClick = (e: any) => {
        const { value, checked } = e.target;
    
        if (checked) {
          setSelectedItems([...selectedItems, value]);
        } else {
          setSelectedItems(selectedItems.filter((item: any) => item !== value));
        }
    };
        
    const { 
        tourActive,
        stepIndex,
        setRunTour,
        setStepIndex
    } = useContext<any>(AppContext);

    setTimeout(() => {
        if(!catalogId || !tourActive) return;
        setRunTour(true);
        stepIndex !== 2 && setStepIndex(2);
    }, 2000);

    const selectAllItems = (e: any) => {
      const { checked } = e.target;
      const collection: any[] = [];
  
      checked && entities.map((entity: any, index: number) => {
        if (entity.entity) {
            entity = entity.entity;
        }
        collection.push(entity.ID);
      })
  
      setSelectedItems(collection);
      setAllItemsChecked(checked);
    };

    const handleToggle = (entity: any) => {};

    const handleAction = (e: any, catalog: any) => {
        const klass = e.target?.classList || '';
        const parentKlass = e.target?.parentElement?.classList || '';

        if (e.target?.type === 'checkbox') return;
        if (klass.contains('MuiModal-backdrop')) return;
        if (klass.contains('view-catalog') || parentKlass.contains('view-catalog')) return;

        FoldersActions.selectedItems = [];
        FoldersActions.catalog = catalog;
        setSelectedItems([]);
        history.push({
            pathname: "/catalog/" + catalog.ID,
            state: {
                from: window.location.pathname,
            },
        });
        history.goForward();
    };

    const handleMeuProperties = (evt: any, entity: any) => {
        setAnchor(evt.target);
        setEntity(entity);
    };

    const handleClose = () => {
        setOpen("");
    };

    useEffect(() => {
        const allObjts = FoldersActions.allEntities
            .filter(
                (entity: any) =>
                    entity.project === catalog.project &&
                    entity.type === 'FILE'
            )
            .map((entity: any) => ({
                type: entity.file_type,
                name: entity.name,
                id: entity.ID,
                project: entity.project,
                file_folder: entity.file_folder
            }));

        setListObjects(allObjts);
    }, []);

    useEffect(() => {
        console.log("listObjects updated :", listObjects);
    }, [listObjects]);

    const sortByDate = (a: any, b: any) => a.file_date && parseInt(a.file_date, 10) > parseInt(b.file_date || '', 10) ? -1 : 1;

    // const getProgressById = (id: string): number | undefined => {
    //     const item = processingIDs.find(entry => entry.id === id);
    //     if(typeof item !== "undefined")
    //         return item?.progress;
    //     else
    //         return 0;
    // };

    const isViewable = (entity: any) => {
        let viewable = false;
        const fileType = entity.file_type;
        const viewType = entity.view_type;
        const fileState = entity.state;

        if (fileType && fileType === "IDXORTHO") return viewable;
        if(fileState && fileState !== 'COMPLETE') return viewable;
        return  viewableEntitiesType.includes(viewType) || Object.keys(defaultViewProgram).includes(fileType);
    };
    const viewCatalog = (entity: any) => {
        if (entity && entity.view_type === "container") {

            
            history.push({
                pathname: "/views/" + entity.ID,
                state: {
                    from: window.location.pathname.replace("/app", ""),
                },
            });
            history.goForward();
        } else {
            let path;
            if (selectedItems.length === 0) {
                path = "/preview/" + entity.ID;
            } else {
                path = "/preview/" + selectedItems.join("+");
            }
            history.push({
                pathname: path,
                state: {
                    from: window.location.pathname,
                },
            });
            history.goForward();
        }
    };

    return !loading ? (
        <Card
            sx={{
                position: 'relative',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                p: '25px',
                m: '0 20px',
                ...(type !== "projects" && type !== "FOLDER" ? {height: "calc(100% - 50px)"} : {} )
            }}
        >
            {type !== "projects" && type !== "FOLDER" ? (
                <EntityProperties entity={catalog} maxHeight="calc(100vh - 450px)" maxWidth="calc(100% - 10px)" />
            ) : (
                <>
                    <EntitiesListHeader />
                    { entities?.length > 0 ? (
                        <List className={classes.list}>
                            {entities.sort(sortByDate).map((entity: any, index: number) => {
                                
                                if (entity.entity) {
                                    entity = entity.entity;
                                }
                                const labelMenuItems = [
                                    ...( entity && entity["version_number"] ? [{ icon: <VerifiedIcon  />, title: 'Set as Active', action: 'activeversion' }] : []),
                                    ...( type === "projects" ? [{ icon: <EditIcon />, title: 'Edit', action: 'edit' }] : [{ icon: <EditIcon />, title: 'Rename', action: 'rename' }]),
                                    { icon: <DeleteIcon />, title: 'Delete', action: 'delete' },
                                    ...(entity && entity.type === 'FILE' && (entity.file_type === 'RAWPC') ? 
                                    [
                                        {icon: <CachedIcon  />, title: 'To Indexed Points', action: 'indexedPoints'},
                                        {icon: <CachedIcon  />, title: 'To Voxel Terrain', action: 'voxelTerrain'}
                                    ] 
                                    : []),
                                     ...(entity && entity.type === 'FILE' && (entity.file_type === 'RAWDH') ? 
                                    [
                                        {icon: <CachedIcon  />, title: 'To Drill Hole Database', action: 'drillHoleDatabase'}
                                    ] 
                                    : []),
                                     ...(entity && entity.type === 'FILE' && (entity.file_type === 'RAWGEOCHEM') ? 
                                    [
                                        {icon: <CachedIcon  />, title: 'To Geo Chem', action: 'geochem'}
                                    ] 
                                    : []),
                                    ...(entity && entity.type === 'FILE' && (entity.file_type === 'RAWMESH') ? 
                                    [
                                        {icon: <CachedIcon  />, title: 'To Indexed Mesh', action: 'indexedMesh'},
                                        {icon: <CachedIcon  />, title: 'To Ortho Voxel Terrain', action: 'orthoVoxelTerrain'},
                                        {icon: <CachedIcon  />, title: 'To Voxelized Mesh', action: 'voxelMesh'}
                                    ] 
                                    : []),
                                    ...(entity && entity.type === 'FILE' && (entity.file_type === 'RAWBM') ? 
                                    [
                                        {icon: <CachedIcon  />, title: 'To Voxel Block Model', action: 'voxelBlockModel'}
                                    ] 
                                    : []),
                                    ...(entity && entity.type === 'FILE' && (entity.file_type === 'ORTHO') ? 
                                    [
                                        {icon: <CachedIcon  />, title: 'To Indexed Imagery', action: 'indexedImagery'}
                                    ] 
                                    : [])
                                ];

                                // onClick={() => launchProcess(process, fileType, catalog.ID)}
                                return (
                                    <ListItem
                                        key={"item-" + index}
                                        sx={{
                                            cursor: 'pointer',
                                            borderTop: 1,
                                            borderTopColor: 'divider',
                                
                                            '&:hover': {
                                            bgcolor: 'action.hover',
                                
                                            '& .ListAction': {
                                                width: { sm: '100%' },
                                                opacity: { sm: 1 },
                                            },
                                
                                            '& .ListTextExtra': {
                                                visibility: { sm: 'hidden' },
                                                opacity: { sm: 0 },
                                            },
                                            },
                                
                                            '& .MuiListItemIcon-root': {
                                            minWidth: 48,
                                            },
                                
                                            [theme.breakpoints.down('sm')]: {
                                                flexWrap: 'wrap',
                                                pl: '0px',
                                                pr: '0px'
                                            },
                                        }}
                                        //className={cx(common.middle, classes.row)}
                                        //style={{ overflow: "hidden" }}
                                        role={undefined}
                                        //dense
                                        onClick={(e) => (handleAction ? handleAction(e, entity) : "")}
                                    >
                                        <Div className={classes.checkbox}>
                                            <Checkbox
                                                edge="start"
                                                tabIndex={-1}
                                                disableRipple
                                                value={entity.ID}
                                                checked={selectedItems.includes(entity.ID)}
                                                //onChange={(_e, checked) => handleCheckboxChange(entity, checked)}
                                                onChange={handleCheckboxClick}
                                                inputProps={{ "aria-labelledby": `checkbox-list-label-${index}` }}
                                                disabled={isDefaultProject || !hasFullAccess}
                                            />
                                        </Div>
                                        <ListItemText
                                            className={cx(common.middle, classes.firstColCheckbox)}
                                            sx={{pl: {xs: '0px', sm: '0px'}}}
                                        >
                                            <div className={common.middle}>
                                                {entity["version_number"] ? (
                                                    <div className={cx(common.middle)}>
                                                        <Div
                                                            sx={{
                                                                textAlign: 'center',
                                                            }}
                                                        >
                                                            <Typography
                                                                fontSize={'12px'}
                                                                variant={'h6'}
                                                                color={catalog.entity["version_active"] === entity["ID"] ? 'rgb(61, 171, 230)' : 'text.secondary'}
                                                                mb={0.25}
                                                            >
                                                                {catalog.entity["version_active"] === entity["ID"] ? 'Active' : 'Version' }
                                                            </Typography>
                                                            
                                                            <Chip
                                                                label={entity["version_number"]}
                                                                size={'small'}
                                                                style={{ backgroundColor: catalog.entity["version_active"] === entity["ID"] ? 'rgb(115, 173, 33)' : theme.palette.text.secondary }}
                                                            />
                                                        </Div>
                                                        {entity["comment"] && entity["comment"] !== "No comment" && (
                                                            <ListItemText className={cx(common.middle)} style={{marginLeft: 10}}>
                                                                <Tooltip title={entity["comment"]} arrow>
                                                                    <Typography className={cx(classes.ellipsis)}>
                                                                        {entity["comment"]}
                                                                    </Typography>
                                                                </Tooltip>
                                                            </ListItemText>
                                                        )}
                                                    </div>
                                                ) : entity.file_type === "FOLDER" ? (
                                                    <>
                                                        <Div sx={{ flexShrink: 0, px: 1 }}>
                                                            <Avatar
                                                                sx={{ width: 37, height: 37, bgcolor: (theme) => alpha(theme.palette.background.default, 0.35), borderRadius: '50%' }}
                                                                src=""
                                                                variant='rounded'
                                                                >
                                                                <Folder style={{ width: '85%', height: '85%' }} sx={{color: theme.palette.text.secondary}} />
                                                            </Avatar>
                                                        </Div>
                                                        <Div
                                                            sx={{
                                                                flexShrink: 0,
                                                                px: 1,
                                                                flex: 1,
                                                                pt: '10px'
                                                            }}
                                                        >
                                                            <Typography variant={'h5'} mb={0.5} fontSize={14}>
                                                                {entity.name}
                                                            </Typography>
                                                            { false  && (
                                                                <Typography
                                                                    fontSize={'12px'}
                                                                    variant={'body1'}
                                                                    color={'text.secondary'}
                                                                    sx={{display: { xs: 'none', sm: 'none', md: 'none', lg: 'none', xl: 'block'}}}
                                                                >
                                                                    {entity.ID}
                                                                </Typography>
                                                            )}
                                                        </Div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Div sx={{ flexShrink: 0, px: 1 }}>
                                                            <Avatar
                                                                sx={{ width: 40, height: 40, bgcolor: (theme) => theme.palette.background.paper, borderRadius: '50%', color: (theme) => theme.palette.text.primary }}
                                                                src=""
                                                                variant='rounded'
                                                                >
                                                                {getIcon(entity)}
                                                            </Avatar>
                                                        </Div>
                                                        <Div
                                                            sx={{
                                                            //width: { xs: 'auto', lg: '25%' },
                                                            flexShrink: 0,
                                                            px: 1,
                                                            flex: { xs: '1', lg: '0 1 auto' },
                                                            pt: '10px'
                                                            }}
                                                        >
                                                            <Typography variant={'h5'} fontSize={14}>
                                                                {entity.name}
                                                            </Typography>
                                                            { false && (
                                                                <Typography
                                                                    fontSize={'12px'}
                                                                    variant={'body1'}
                                                                    color={'text.secondary'}
                                                                    sx={{display: { xs: 'none', sm: 'none', md: 'none', lg: 'none', xl: 'block'}}}
                                                                >
                                                                    {entity.ID}
                                                                </Typography>
                                                            )}
                                                        </Div>
                                                    </>
                                                )}
                                            </div>
                                        </ListItemText>
                                        {entity["user"] && entity["user"] !== "Unknown" && (
                                            <Div sx={{display: { md: 'none', lg: 'block' }}}>
                                                <ListItemText className={cx(common.middle, common.mediumLabel)}>
                                                    <Tooltip title={entity["user"]} arrow>
                                                        <Typography className={cx(classes.user)}>
                                                            {entity["user"].substring(0, 5)}
                                                        </Typography>
                                                    </Tooltip>
                                                </ListItemText>
                                            </Div>
                                        )}
                                        {type !== "projects" ? (
                                            <Div className={common.middle} sx={{display: { xs: 'none', sm: 'none', md: 'none', lg: 'none', xl: 'flex' }}}>
                                                <ListItemText className={cx(common.middle, classes.secondCol)}>
                                                    <div className={common.middle}>
                                                        <Typography
                                                            align="center"
                                                            fontSize={'13px'}
                                                            variant={'body1'}
                                                            color={'text.secondary'}
                                                            style={{paddingRight: entity.file_type === "FOLDER" && !entity.files ? '9px' : ''}}
                                                        >
                                                            {Utils.formatDateWithTime(entity ? entity.file_date : "")}
                                                        </Typography>
                                                    </div>
                                                </ListItemText>
                                                {entity.file_type === "FOLDER" ? (
                                                    <div className={common.middle}>
                                                        <ListItemText className={cx(common.middle, classes.thirdCol)}>
                                                            <div className={common.middle}>
                                                                <Typography 
                                                                    fontSize={'13px'}
                                                                    variant={'body1'}
                                                                    color={'text.secondary'}
                                                                >
                                                                    {entity.files ? entity.files.length + " Items" : ""}
                                                                </Typography>
                                                            </div>
                                                        </ListItemText>
                                                        <ListItemText
                                                            className={cx(common.middle, classes.fourthCol)}
                                                        ></ListItemText>
                                                    </div>
                                                ) : (
                                                    <div className={common.middle} style={{paddingLeft: '8px', paddingTop: '0px'}}>
                                                        <ListItemText className={cx(common.middle, classes.thirdCol)}>
                                                            <div className={common.middle}>
                                                                <div className={cx(common.middle, common.mediumLabel)}>
                                                                    {entity.state === "COMPLETE" ? (
                                                                        <CheckCircleOutlineRounded style={{ color: "#4caf50", width: 20, height: 20 }} />
                                                                    ) : entity.state === "PARTIAL" ? (
                                                                        // <CircularProgressWithLabel
                                                                        //     value={parseInt(entity.partial_progress)}
                                                                        //     style={{ width: 24, height: 24 }}
                                                                        // />
                                                                        <CircularProgressWithLabel
                                                                            value={processingIDs[entity["ID"]]?.progress || 0}
                                                                            style={{ width: 24, height: 24 }}
                                                                        />
                                                                    ) : (
                                                                        <ErrorOutlineRounded style={{ color: "#F08B7B", width: 20, height: 20 }} />
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </ListItemText>
                                                        <ListItemText className={cx(common.middle, classes.labelCol)}>
                                                            <div className={common.middle}>
                                                                <div className={cx(common.middle)}>
                                                                    {
                                                                        entity.state === "PARTIAL" ?
                                                                            <Typography 
                                                                                sx={{ 
                                                                                    fontSize: '11px !important',
                                                                                    whiteSpace: 'nowrap',

                                                                                    '@media (max-width:1400px)': {
                                                                                        whiteSpace: 'normal', 
                                                                                    }
                                                                                }}
                                                                                variant={'body1'}
                                                                                color={'#3DABE6'}
                                                                            >
                                                                                {substringLabel(processingIDs[entity["ID"]]?.label) || "Waiting in queue..."}
                                                                                                                                                                                                                            
                                                                        </Typography>
                                                                    : ""
                                                                    }
                                                                </div>
                                                            </div>
                                                        </ListItemText>
                                                        <ListItemText className={cx(common.middle, classes.fourthCol)}>
                                                            <div className={common.middle}>
                                                                <Typography 
                                                                    fontSize={'13px'}
                                                                    variant={'body1'}
                                                                    color={'text.secondary'}
                                                                >
                                                                    {entity.file_size
                                                                        ? Utils.numberWithCommas(
                                                                            Math.round(entity.file_size / 1024)
                                                                        ) + " KB"
                                                                        : "N/A"}
                                                                </Typography>
                                                            </div>
                                                        </ListItemText>
                                                        <ListItemText className={cx(common.middle, classes.thirdCol)}>
                                                            <div className={common.middle}>
                                                                { isViewable(entity) ? 
                                                                    <Tooltip title="Preview the view" placement="top" arrow>
                                                                        <VisibilityIcon  
                                                                            className="view-catalog"
                                                                            sx={{width: 20, height: 20, color: (theme) => theme.palette.text.disabled, mr: '10px', opacity:"0.65"}} 
                                                                            onClick={() => viewCatalog(entity) }
                                                                        /> 
                                                                    </Tooltip>
                                                                    : 
                                                                    <></> 
                                                                }
                                                            </div>
                                                        </ListItemText>
                                                    </div>
                                                )}
                                            </Div>
                                        ) : (
                                            ""
                                        )}
                                        {
                                            hasProjectAccess && !isDefaultProject ? (
                                                <JumboDdMenu
                                                    icon={<Tooltip title="More actions" placement="top" arrow><MoreHorizIcon /></Tooltip>}
                                                    menuItems={[
                                                        ...labelMenuItems,
                                                        ...( isViewable(entity) ? [{ icon: <VisibilityIcon />, title: 'View', action: 'view' }] : []),
                                                    ]}
                                                    onClickCallback={handleMoreAction}
                                                    onClick={(evt: any) => {
                                                        setAnchor(evt.target);
                                                        setEntity(entity);
                                                        dispatch(addRawData([entity.ID]));
                                                    }}
                                                />
                                            ) : 
                                            <Tooltip title="Read Only" placement="top" arrow>
                                                <LockIcon sx={{width: 20, height: 20, color: (theme) => theme.palette.text.disabled, mr: '10px', opacity:"0.65"}} />
                                            </Tooltip>
                                        }
                                    </ListItem>
                                );
                            })}
                        </List>
                    ) : (
                        <Typography
                            fontSize={'18px'}
                            variant={'body1'}
                            color={'text.secondary'}
                            sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '50px 0'}}
                        >
                            No entities found
                        </Typography>
                    )}
                </>
            )}
            <RenameItemPanel open={open === "renameItem"} catalog={entity} handleClose={handleClose} title={entity?.type === 'PROJECT' ? 'Project Rename' : 'Rename'} />
            <DeleteItemsPanel open={open === "deleteItem"} handleClose={handleClose} />
            <ActivateVersionPanel
                open={open === "activateItem"}
                handleClose={handleClose}
                catalog={catalog}
                version={entity?.ID}
                product={catalog?.entity?.ID}
            />
        </Card>
    ) : "";
}

export default function CheckboxList(props: { catalogId: string; catalog: any; setCatalog: any; cacheLastUpdate: number; entities: any; loadEntities: boolean; }) {
    //var { catalog } = props;
    // console.log("catalog:", catalog);
    const { 
        catalog
    } = useContext<any>(CatalogContext);
    
    return (
        <CustomScroll
            autoHeightMax={"100%"}
            style={{ width: "100%", height: "100%", overflowX: "hidden"/*, backgroundColor: panelBackgroundColor*/ }}
        >
            {catalog ? <Entities {...props} /> : <Redirect to="/catalog" />}
        </CustomScroll>
    );
}
